import { CanonicalSchema } from './types';

/** A new contract version; older publications retain their original schema. */
export const strictBillSchema = (previous: CanonicalSchema): CanonicalSchema => ({
  ...previous,
  id: 'bill-4',
  version: 4,
  title: 'Canonical bill',
  jsonSchema: undefined,
  fields: [
    ...previous.fields.filter((field) => !field.path.startsWith('lines[].')),
    { path: 'lines[].itemCode', type: 'string', required: true },
    { path: 'lines[].itemName', type: 'string', required: false },
    { path: 'lines[].qty', type: 'number', required: true },
    { path: 'lines[].rate', type: 'number', required: true },
    { path: 'lines[].taxPct', type: 'number', required: false },
  ],
});
